import * as React from 'react'

import { graphql } from '~publish/graphql'

import { getMentionedChannelTextParts } from '../../util/getMentionedChannelTextParts'
import type { MentionedChannel } from '../../util/getMentionedChannelTextParts'

import styles from './MentionedChannelText.module.css'

import type { JSX } from 'react'

/** The channel fields the highlight matches on; spread on the channel query. */
export const MentionedChannelText_Channel = graphql(/* GraphQL */ `
  fragment MentionedChannelText_Channel on Channel @_unmask {
    name
    displayName
  }
`)

/** Highlight class for surfaces that render their own mention markup. */
export const mentionedChannelClassName = styles.mentionedChannel

type MentionedChannelTextProps = {
  text: string
  channel: MentionedChannel
}

/**
 * Renders text with the channel's own name highlighted. Place inside a
 * `Text`; it only emits inline content.
 * @see getMentionedChannelTextParts
 */
export const MentionedChannelText = ({
  text,
  channel,
}: MentionedChannelTextProps): JSX.Element => (
  <>
    {getMentionedChannelTextParts(text, channel).map((part) =>
      part.isMentionedChannel ? (
        <span key={part.key} className={styles.mentionedChannel}>
          {part.text}
        </span>
      ) : (
        <React.Fragment key={part.key}>{part.text}</React.Fragment>
      ),
    )}
  </>
)

MentionedChannelText.displayName = 'MentionedChannelText'
